import * as yup from 'yup';

export const validationSchema = yup.object({
    roleTitle: yup
        .string()
        .required("Required"),
    userRouteType: yup
        .string()
        .required("Required"),
    // description: yup
    //     .string()
    //     .required("Required"),
})

export const initialValues = {
    roleTitle: "",
    userRouteType: "",
    description: "",
    status: true,
    userId: [],
    branchUserId: []
}